import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { RideButton } from '@rimac-seguros/ride-system-components';

import { useAppContext } from '../../../../AppProvider';
import { errorPage, errorCustomPage } from '../../../../utils/texts';
import { capitalize } from '../../../../utils/helpers';
import { useHistory } from '../../../../hooks/useHistory';
import { Layout } from '../../../../components/organisms';
import ThankYouImage from '../../../../assets/ty-page/asesora.png';
import ThankYouImageMb from '../../../../assets/ty-page/asesora-mb.jpg';
import Clock from '../../../../assets/icons/gl_clock.svg';
import { ReactComponent as Phone } from '../../../../assets/icons/ic-phone.svg';
import { getTagActionName } from '../../../../utils/analytics';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';

const ErrorPage = ({ custom }) => {
  const { navigate } = useHistory();
  const pageTexts = custom ? errorCustomPage : errorPage;
  const {
    state:
      {
        client,
        nonExistentDocument,
      },
    dispatch,
  } = useAppContext();
  const {
    title, title2, subtitle, listText, advice, btnText, telephone,
  } = pageTexts;
  const firstName = client.nombres ? capitalize(client.nombres.split(' ')[0]) : '';

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      dispatch({ type: 'SAVE_CLIENT', payload: {} });
    };
  }, []);

  const actionEvent = () => {
    if (!custom && nonExistentDocument) {
      getTagActionName('Salud Salud Flexible', 'Interacciones', 'Error Documento inexistente', btnText, 'trackAction');
      dispatch({ type: 'NON_EXISTENT_DOCUMENT', payload: false });
    }
    navigate('/comprar/seguro-salud-flexible');
  };

  const customTitle = firstName ? `${firstName}${title}` : title2;
  const pageTitle = custom ? customTitle : title;

  return (
    <Layout>
      <RegisterAuditory
        authoring={{
          paso: 8,
          pasoDescripcion: 'PASO_GRACIAS_NEGOCIO',
        }}
      />
      <div className="ty-page">
        <div className="img-mobile-cont">
          <img className="img-mobile" src={ThankYouImageMb} alt="img-mobile" />
        </div>
        <div className="content-full ty-page">
          <div className="content-full__left">
            <img className="img-desktop" src={ThankYouImage} alt="img-desktop" />
          </div>
          <div className="content-full__right">
            <div className="typage-title">
              {pageTitle}
            </div>
            <div className="typage-description" dangerouslySetInnerHTML={{ __html: subtitle }} />
            <div className="typage-list">
              <div>
                <img className="typage-list__img" src={Clock} alt="img-thank-u-page" />
              </div>
              <div className="typage-list__info">
                <ul className="list-disc">
                  {
                    listText.map((text, i) => <li key={`text-${i}`}><strong>{text}</strong></li>)
                  }
                </ul>
              </div>
            </div>
            <div className="typage-advice">
              {advice}
            </div>
            <div className="mt-8 typage-list phone-wrapper">
              <div className="typage-list__img phone">
                <Phone />
              </div>
              <a
                rel="noopener noreferrer"
                href={`tel:01${telephone.trim()}`}
              >
                <strong><span>{`${telephone}`}</span></strong>
              </a>

            </div>
            <div className="typage-button">
              <RideButton
                text={btnText}
                size="x-large"
                onClick={() => actionEvent()}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

ErrorPage.propTypes = {
  custom: PropTypes.bool,
};

ErrorPage.defaultProps = {
  custom: false,
};

export default ErrorPage;
